/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import momentPropTypes from 'react-moment-proptypes';
import { forbidExtraProps } from 'airbnb-prop-types';
import { Manager, Reference, Popper } from 'react-popper';
import moment from 'moment';
import omit from 'lodash/omit';
import uniqueID from 'helpers/uniqueID';
import { CSSTransition } from 'react-transition-group';
import { DayPickerSingleDateController, isInclusivelyAfterDay } from 'react-dates';
import 'moment/locale/fr';
export default function DatePickerHOC(InterfaceComponent) {
    class DatePickerControllerWrapper extends Component {
        constructor(props) {
            super(props);

            this.state = {
                isMobile: window.innerWidth <= 767,
                calendarVisible: false,
                language : '',
                focusedInput: 'date',
            };

            this.resizeTimer = null;
            this.showCalendar = this.showCalendar.bind(this);
            this.hideCalendar = this.hideCalendar.bind(this);
            this.dateChanged = this.dateChanged.bind(this);
            this.renderCalendarInfo = this.renderCalendarInfo.bind(this);
            this.windowResize = this.windowResize.bind(this);
            this.handleCalendarBlur = this.handleCalendarBlur.bind(this);
            this.customDateChanged = this.customDateChanged.bind(this);
            this.escFunction = this.escFunction.bind(this);
            this.focusChanged = this.focusChanged.bind(this);
            this.validateDate = this.validateDate.bind(this);
            this.timeChanged = this.timeChanged.bind(this);
        }

        componentDidMount() {
            const app = document.getElementById('app');
            const { language } = app.dataset;
            this.setState({ language : language });

            window.addEventListener('resize', this.windowResize, true);
            document.addEventListener('keydown', this.escFunction, false);
            moment.locale(language);
        }

        escFunction(event) {
            if (event.key === 'Escape') {
                this.hideCalendar();
            }
        }

        handleCalendarBlur(event) {
            let node = event.target;

            let within = false;

            while (node !== event.currentTarget) {
                node = node.parentNode;

                if (node.classList.contains('cldr_container')) {
                    within = true;
                    break;
                }
            }

            if (!within) {
                this.hideCalendar();
            }
        }

        windowResize() {
            const { isMobile } = this.state;
            const newIsMobile = window.innerWidth <= 767;

            if (newIsMobile !== isMobile) {
                if (isMobile) {
                    document.body.classList.remove('modal-open');
                } else {
                    // commented for body scroll issue in mobile
                    // document.body.classList.add('modal-open');
                }
                if (this.resizeTimer !== null) clearTimeout(this.resizeTimer);
                this.resizeTimer = setTimeout(() => {
                    this.setState({ isMobile: newIsMobile });
                });
            }
        }

        showCalendar(e) {
            const { calendarVisible, isMobile } = this.state;
            
            if (calendarVisible) {
                this.hideCalendar();
            }

            e.stopPropagation();
            if (!calendarVisible) {
                const app = document.getElementById('app');
                app.addEventListener('click', this.handleCalendarBlur, true);

                if (isMobile) {
                    document.body.classList.add('modal-open5');
                }
                this.setState({ calendarVisible: true });
            }
        }

        hideCalendar() {
            const { isMobile, calendarVisible } = this.state;
            const app = document.getElementById('app');
            app.removeEventListener('click', this.handleCalendarBlur, true);

            if (isMobile) {
                document.body.classList.remove('modal-open');
            }
            if (calendarVisible) {
                this.setState({ calendarVisible: false });
            }
        }

        dateChanged(date) {
            const { onDateChange } = this.props;

            if (date !== null ) {
                this.hideCalendar();
            }

            onDateChange(date);
        }

        timeChanged(value, element) {
            const { date , onDatesChange } = this.props;
            const newDate = date !== null ? moment(date) : null;
            // alert("time changed")
            const newState = {};
            if (element === 'start') {
                newState.startTime = value;
                if (newDate !== null) {
                    newDate.set('hour', value);
                }
            } 

            this.setState(newState);
            onDatesChange(newDate);
        }

        validateDate(e) {
            const date = e.target.value;
            const fieldName = e.target.name;
        }

        customDateChanged(e) {
            const date = e.target.value;
            const { onCustomDateChange } = this.props;
            onCustomDateChange(date);
        }
        focusChanged(input) {
            this.setState({
                // Force the focusedInput to always be truthy so that dates are always selectable
                focusedInput: !input ? 'date' : input,
            });
        }
        renderCalendarInfo() {
            const { calendarInfo } = this.props;
            return (
                <div className="calendar-footer-section">
                        <div className="input-buttons theme-3 list-inline px-3 mt-4">
                            {calendarInfo.options && calendarInfo.options.map((option) => {
                                const id = uniqueID();
                                return (
                                    <>
                                        <input
                                            type="radio"
                                            id={id}
                                            value={option.value}
                                            checked={calendarInfo.selected === option.value}
                                            onChange={() => { calendarInfo.onChange(option.value); }}
                                            className="h-auto"
                                        />
                                        <label htmlFor={id} className="mr-2">
                                            <span>
                                                {option.text}
                                            </span>
                                        </label>
                                    </>
                                );
                            })}
                        </div>
                </div>

            );
        }

        renderDayContents(day, modifiers) {
            return (
                <div className={`calendar-date ${modifiers.has('selected') ? 'calendar-selected-date' : ''}`}>
                    {day.format('D')}
                </div>
            );
        }

        render() {
            const propValues = omit(this.props, [
                'minDate',
                'dateId',
                'label',
                'datePlaceholderText',
                'onDateChange',
                // 'date'
            ]);

            const {
                date,
                label,
                minDate,
                dateId,
                datePlaceholderText,
                depDate,
                isStartDateValid,
                activeTab,
                dateFormat,
                validateDate,
            } = this.props;
            // alert(depDate)
            const { isMobile, calendarVisible, focusedInput } = this.state;
            return (
                <div className="cldr_container">
                    <Manager>
                        <Reference>
                            {({ ref }) => (
                                <div ref={ref}>
                                    <InterfaceComponent
                                        date={date}
                                        datePlaceholderText={datePlaceholderText}
                                        label={label}
                                        dateId={dateId}
                                        onFocus={this.focusChanged}
                                        showCalendar={this.showCalendar}
                                        customDateChanged={this.customDateChanged}
                                        depDate={depDate}
                                        isStartDateValid={isStartDateValid}
                                        dateFormat={dateFormat}
                                        validateDate={this.validateDate}
                                        onTimeChange={this.timeChanged}

                                    />
                                </div>
                            )}
                        </Reference>

                        <CSSTransition in={calendarVisible} timeout={200} classNames="fade" mountOnEnter unmountOnExit>
                            <div>
                                {(!isMobile && (
                                    <Popper placement="bottom-end">
                                        {({ ref, style }) => (
                                            <div className="border-0 box-shadow rounded datepicker" ref={ref} style={style}>

                                                <button type="button" className="btn-unstyled px-2 position-absolute right z-index-1 border-0" onClick={() => { this.hideCalendar(); }}>
                                                    <svg className="icon" title="">
                                                        <use xmlnsXlink="http://www.w3.org/2000/svg" xlinkHref="/img/icons/icon-defs.svg#icon-close" />
                                                    </svg>
                                                </button>

                                                <DayPickerSingleDateController
                                                    {...propValues}
                                                    date={isStartDateValid ? date : null} 
                                                    renderCalendarInfo={this.renderCalendarInfo}
                                                    renderDayContents={this.renderDayContents}
                                                    onFocusChange={this.focusChanged}
                                                    focusedInput={focusedInput}
                                                    onDateChange={this.dateChanged}
                                                    daySize={50}
                                                    minimumNights={1}
                                                    isOutsideRange={(day) => !isInclusivelyAfterDay(day, moment().add(minDate, 'days'))
                                                        || (isInclusivelyAfterDay(day, moment().add(11, 'months').subtract(5, 'days')) && activeTab != 'dynamic')}
                                                />
                                            </div>
                                        )}
                                    </Popper>
                                )) || (
                                    <div className="day-picker-mobile-container">
                                        <div className="row calendar-header-section">
                                            <div className="col-10">
                                                <div className="py-2 pl-2 h6 black-text mb-0">Select Dates</div>
                                            </div>
                                            <button type="button" className="btn-unstyled px-2 position-absolute right z-index-1 border-0" onClick={() => { this.hideCalendar(); }}>
                                                <svg className="icon" title="">
                                                    <use xmlnsXlink="http://www.w3.org/2000/svg" xlinkHref="/img/icons/icon-defs.svg#icon-close" />
                                                </svg>
                                            </button>
                                        </div>

                                        <DayPickerSingleDateController
                                            {...propValues}
                                            renderCalendarInfo={this.renderCalendarInfo}
                                            renderDayContents={this.renderDayContents}
                                            onFocusChange={this.focusChanged}
                                            focusedInput={focusedInput}
                                            onDateChange={this.dateChanged}
                                            daySize={50}
                                            noBorder
                                            orientation="verticalScrollable"
                                            minimumNights={1}
                                            isOutsideRange={(day) => !isInclusivelyAfterDay(day, moment().add(minDate, 'days'))
                                                    || (isInclusivelyAfterDay(day, moment().add(11, 'months').subtract(5, 'days')) && activeTab != 'dynamic')}
                                        />
                                    </div>

                                )}
                            </div>
                        </CSSTransition>
                    </Manager>
                </div>
            );
        }
    }

    DatePickerControllerWrapper.propTypes = forbidExtraProps({
        date: momentPropTypes.momentObj,
        autoFocus: PropTypes.bool,
        initialDate: momentPropTypes.momentObj,
        showInput: PropTypes.bool,

        allowUnselect: PropTypes.bool,
        keepOpenOnDateSelect: PropTypes.bool,
        isOutsideRange: PropTypes.func,
        isDayBlocked: PropTypes.func,
        isDayHighlighted: PropTypes.func,

        // DayPicker props
        enableOutsideDays: PropTypes.bool,
        numberOfMonths: PropTypes.number,
        orientation: PropTypes.oneOf(['horizontal', 'vertical', 'verticalScrollable']),
        withPortal: PropTypes.bool,
        initialVisibleMonth: PropTypes.func,
        renderCalendarInfo: PropTypes.func,

        navPrev: PropTypes.node,
        navNext: PropTypes.node,
        renderNavPrevButton: PropTypes.func,
        renderNavNextButton: PropTypes.func,

        onPrevMonthClick: PropTypes.func,
        onNextMonthClick: PropTypes.func,
        onOutsideClick: PropTypes.func,
        renderCalendarDay: PropTypes.func,
        renderDayContents: PropTypes.func,

        // i18n
        monthFormat: PropTypes.string,

        isRTL: PropTypes.bool,

        label: PropTypes.string,
        minDate: PropTypes.number,
        datePlaceholderText: PropTypes.string,
        calendarInfo: PropTypes.instanceOf(Object),
        dateId: PropTypes.string.isRequired,
        onDateChange: PropTypes.func.isRequired,
    });

    DatePickerControllerWrapper.defaultProps = {
        date: null,
        autoFocus: false,
        initialDate: null,
        showInput: false,

        // day presentation and interaction related props
        allowUnselect: false,
        renderCalendarDay: undefined,
        renderDayContents: null,
        isDayBlocked: () => false,
        isOutsideRange: (day) => !isInclusivelyAfterDay(day, moment()),
        isDayHighlighted: () => false,
        enableOutsideDays: false,

        // calendar presentation and interaction related props
        orientation: 'horizontal',
        withPortal: false,
        initialVisibleMonth: null,
        numberOfMonths: 2,
        onOutsideClick() { },
        keepOpenOnDateSelect: false,
        renderCalendarInfo: null,
        isRTL: false,

        // navigation related props
        navPrev: null,
        navNext: null,
        renderNavPrevButton: null,
        renderNavNextButton: null,
        onPrevMonthClick() { },
        onNextMonthClick() { },

        // internationalization
        monthFormat: 'MMMM YYYY',

        label: 'Date',
        minDate: 2,
        datePlaceholderText: 'Select Date',
        calendarInfo: {},
    };

    return DatePickerControllerWrapper;
}
